// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3TPVn","alertIcon":"ConfirmModal_alertIcon__3ICSs"};